'use client'
import InputField from '@a24/form/InputField'
import SelectField from '@a24/form/SelectField'
import Divider from '@a24/ui/Divider'
import Title from '@a24/ui/Title'
import { addYears } from 'date-fns'

const yearList = Array.from({ length: 10 }, (_, i) => {
  const currDate = new Date()
  const fullYear = addYears(currDate, i).getFullYear()

  return {
    value: (fullYear % 100).toString(),
    label: fullYear.toString()
  }
})

const PaymentForm = () => {
  return (
    <>
      <Title className='heading-md mb-6' level='h2' text='Payment info' />
      <Divider className='mb-8' />
      <div className='grid md:flex gap-6'>
        <SelectField
          outerWrapperClassName='w-full label-md'
          name='paymentMethodId'
          label='Payment type'
          initialValue='3C7D508F-93C5-49BA-A74E-04CA1A251C7B'
          optionMatcher={(source, target) => source === target}
          options={[
            {
              label: 'Credit Card',
              value: '3C7D508F-93C5-49BA-A74E-04CA1A251C7B'
            }
          ]}
          rules={{
            required: 'Card number is required'
          }}
        />
        <InputField
          outerWrapperClassName='w-full label-md'
          name='Payment::account_number'
          label='Card number'
          // TODO : A library here would be 10 million times better
          // onChange={(e) => {
          //   let cardNumber = ''
          //   e.persist()
          //   const caretStart = e.target.selectionStart || 0
          //   const caretEnd = e.target.selectionEnd || 0
          //   const numberOfOriginalSpaces = e.target.value.split(' ').length - 1
          //   const isCarretAtEnd = e.target.value.length === caretStart
          //   const digitArray = e.target.value.replaceAll(' ', '').split('')
          //   const willCaretJumpSpace =
          //     (caretStart -
          //       e.target.value.slice(0, caretStart).replace(/(?! )./g, '')
          //         .length) %
          //       4 ===
          //     0
          //   // update the state and reset the caret
          //   digitArray.forEach((digit, index) => {
          //     cardNumber += digit
          //     if ((index + 1) % 4 === 0 && index < digitArray.length - 1) {
          //       cardNumber += ' '
          //     }
          //   })
          //   e.target.value = cardNumber
          //   const numberOfAddedSpaces =
          //     cardNumber.split(' ').length - 1 - numberOfOriginalSpaces
          //   if (isCarretAtEnd) {
          //     e.target.setSelectionRange(cardNumber.length, cardNumber.length)
          //     return
          //   }
          //   if (!willCaretJumpSpace) {
          //     e.target.setSelectionRange(caretStart, caretEnd)
          //     return
          //   }
          //   e.target.setSelectionRange(
          //     caretStart + numberOfAddedSpaces,
          //     caretEnd + numberOfAddedSpaces
          //   )
          // }}
          inputMode='numeric'
          autoComplete='cc-number'
          placeholder='xxxx xxxx xxxx xxxx'
          type='tel'
          rules={{
            maxLength: 19,
            minLength: 13,
            pattern: /[0-9\s]{13,19}/,
            required: 'Credit Number is required'
          }}
        />
      </div>
      <div className='grid mt-6 md:flex md:mt-10 gap-6 mb-24'>
        <div className='grid md:flex gap-6 w-full'>
          <SelectField
            name='Payment::expiration_date_month'
            outerWrapperClassName='w-full label-md'
            options={[
              { value: '01', label: '01' },
              { value: '02', label: '02' },
              { value: '03', label: '03' },
              { value: '04', label: '04' },
              { value: '05', label: '05' },
              { value: '06', label: '06' },
              { value: '07', label: '07' },
              { value: '08', label: '08' },
              { value: '09', label: '09' },
              { value: '10', label: '10' },
              { value: '11', label: '11' },
              { value: '12', label: '12' }
            ]}
            label='Expiry Date'
            placeholder={'Month'}
            rules={{
              required: 'Card expiration month is required'
            }}
            x-autocompletetype='cc-exp-month'
          />
          <SelectField
            name='Payment::expiration_date_year'
            outerWrapperClassName='w-full label-md'
            options={yearList}
            placeholder='Year'
            label='&nbsp;'
            rules={{
              required: 'Card expiration year is required'
            }}
            x-autocompletetype='cc-exp-year'
          />
          <InputField
            outerWrapperClassName='w-full label-md'
            placeholder='123'
            name='Payment::cvv_code'
            autoComplete='cc-csc'
            x-autocompletetype='cc-csc'
            label='CVV'
            type='tel'
            rules={{
              validate: (value) => {
                const isValid = /[0-9]{3,4}/.test(value)
                return isValid || 'invalid cvv'
              },
              required: 'cvv is required'
            }}
          />
        </div>

        <InputField
          outerWrapperClassName='w-full label-md'
          placeholder='Jay Doe'
          name='Payment::account_name'
          autoComplete='cc-account_name'
          label='Name on card'
          type='text'
          rules={{
            maxLength: 50,
            required: 'Name on card is required'
          }}
        />
      </div>
    </>
  )
}

export default PaymentForm
